import { ColumnDef } from "@tanstack/react-table";
import { formatPhoneNumber } from "@/core/utils/phone";
import { CustomerWithReferralsAndPayouts } from "@/customer/customer";

export const PhoneCol = (): ColumnDef<CustomerWithReferralsAndPayouts> => ({
  header: "Phone number",
  accessorFn: (row) => formatPhoneNumber(row.phone_number),
  size: 150,
  minSize: 150,
  maxSize: 150,
  enableSorting: false,
});
